import { render } from "./BaseSeparator.vue?vue&type=template&id=edfcf172"
const script = {}

import exportComponent from "/home/runner/work/megaluzz-client/megaluzz-client/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__